/* eslint-disable max-len */
/* eslint-disable indent */
const hasContexts = (/** @type {Array<string>} */contexts) => contexts.every(context => window.contexts.includes(context));

import widgetsMgr from 'widgets/widgetsMgr';

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['account', 'adyen']),
    load: () => Promise.all([
        import(/* webpackChunkName: 'account.adyen' */ './widgets/account/AdyenAddPaymentMethodForm').then(d => d.default)
    ]).then(deps => {
        const [
            AdyenAddPaymentMethodForm
        ] = deps;

        return {
            listId: 'account.payment.adyen',
            widgetsDefinition: () => [
                ['adyenAddPaymentMethodForm', AdyenAddPaymentMethodForm, 'addPaymentMethodForm']
            ]
        };
    })
});

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout', 'adyen']),
    load: () => Promise.all([
        import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/AdyenPaymentAccordion').then(d => d.default),
        import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/PaymentAccordionItemAdyenScheme').then(d => d.default),
        import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/PaymentAccordionItemAdyenComponent').then(d => d.default),
        import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/PaymentAccordionItemAdyenPayPal').then(d => d.default),
        import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/AdyenSummaryCheckoutMixin').then(d => d.default)
    ]).then(deps => {
        const [
            AdyenPaymentAccordion,
            PaymentAccordionItemAdyenScheme,
            PaymentAccordionItemAdyenComponent,
            PaymentAccordionItemAdyenPayPal,
            AdyenSummaryCheckoutMixin
        ] = deps;

        return {
            listId: 'checkout.adyen',
            widgetsDefinition: () => [
                    ['checkoutMgr', AdyenSummaryCheckoutMixin, 'checkoutMgr'],
                // accordion / paymentAccordion
                    ['paymentAccordion', AdyenPaymentAccordion, 'paymentAccordion'],
                // accordionItems / paymentAccordionItem
                    ['paymentAccordionItemAdyenComponent', PaymentAccordionItemAdyenComponent, 'paymentAccordionItem'],
                    ['paymentAccordionItemAdyenScheme', PaymentAccordionItemAdyenScheme, 'paymentAccordionItemAdyenComponent'],
                    ['paymentAccordionItemAdyenPayPal', PaymentAccordionItemAdyenPayPal, 'paymentAccordionItemAdyenComponent']
            ]
        };
    })
});
